import React from "react";
import styled, { css } from "styled-components";
import withTheme from "../styles/withTheme";

const InputContainer = styled.div`
  position: relative;
  max-width: 500px;
`;

const InputIcon = styled.i`
  position: absolute;
  color: #999999;
  top: 10px;
  left: 15px;
  & {
    font-size: 18px;
  }
`;

const InputComponent = styled.input`
  width: 100%;
  padding: 8px;
  border: 1px solid #e6e6e6;
  background-color: #fafafa;
  font-size: 16px;
  box-sizing: border-box;
  ${props =>
    props.icon &&
    css`
      padding-left: 48px;
    `} &:focus {
    ${props => css`
      border-color: ${props.mainVisual};
      outline: 0;
    `};
  }
`;

const PropTypes = {};
const DefaultProps = {};

export const Input = props => (
  <InputContainer>
    {props.icon && <InputIcon className={`fa ${props.icon}`} />}
    <InputComponent {...props} />
  </InputContainer>
);

Input.propTypes = PropTypes;
Input.defaultProps = DefaultProps;

export const mapThemeToProps = theme => {
  return {
    mainVisual: theme.color.mainVisual
  };
};

export default withTheme(mapThemeToProps)(Input);



// WEBPACK FOOTER //
// ./src/legacy-tv-ui/Input/Input.js